/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Language_LabelInputs */

const en_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const fr_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const de_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const it_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua`)
};

const ru_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык`)
};

const es_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const zh_cn2_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const ja_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

const hi_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा`)
};

const pt_pt2_audio_embed_export_output_language_label = /** @type {(inputs: Audio_Embed_Export_Output_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguagem`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Audio_Embed_Export_Output_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_language_label = /** @type {((inputs?: Audio_Embed_Export_Output_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_language_label(inputs)
	if (locale === "de") return de_audio_embed_export_output_language_label(inputs)
	if (locale === "it") return it_audio_embed_export_output_language_label(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_language_label(inputs)
	if (locale === "es") return es_audio_embed_export_output_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_language_label(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_language_label(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_language_label(inputs)
	return en_audio_embed_export_output_language_label(inputs)
});